import React from "react";
import { Skeleton as MaterialUISkeleton } from "@material-ui/lab";

function Skeleton() {
  return (
    <div
      style={{ width: `600px`, maxWidth: `85vw`, margin: `0 auto` }}
      data-testid="skeleton"
    >
      <div style={{ margin: `1em 0` }}>
        <MaterialUISkeleton variant="text" />
        <MaterialUISkeleton variant="text" />
        <MaterialUISkeleton variant="text" />
      </div>
      <div style={{ margin: `1em 0` }}>
        <MaterialUISkeleton variant="text" />
        <MaterialUISkeleton variant="text" />
        <MaterialUISkeleton variant="text" />
        <MaterialUISkeleton variant="text" />
      </div>
      <div style={{ margin: `1em 0` }}>
        <MaterialUISkeleton variant="text" />
        <MaterialUISkeleton variant="text" />
      </div>
    </div>
  );
}

export default Skeleton;
